import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './InstrutorView.css'
import brasao from '../../assets/brasilNav.png'
import assinatura from '../../assets/assPresidente.png'

const InstrutorView = (props) => {
    const [processo, setProcesso] = useState({ dataCriacao: '' })
    const id = props.id || window.location.pathname.slice(21)

    useEffect(() => {
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const voltar = () => {
        window.location = `/etica/documentosPed/${processo._id}`
    }

    const imprimir = (e) => {
        window.print()
    }

    if (processo && processo.membros) {
        return (
            <React.Fragment>
                <div className="container iBranco">
                    <img src={brasao} alt="Brasil" className='brasaoPed' />
                    <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                    <div className="iDivLabels">
                        <div className="iLabels">PORTARIA Nº {processo.membros.portaria}/{processo.membros.anoPortaria}</div>
                        <div className="iLabels">{processo.membros.dateI.slice(0, 10)}</div>
                    </div>
                    <div className="iDiv">
                        Nomeia o(a) {processo.membros.instrutorProfissao} {processo.membros.instrutorPronome}
                        &nbsp; {processo.membros.instrutor},
                        <br />
                        CREFITO {processo.membros.instrutorCrefito} para exercer a função de INSTRUTOR do
                        <br />
                        Processo Ético Disciplinar nº {processo.numeroPed}.
                    </div>
                    <div className="iDivTexto">
                        O Presidente do Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região - CREFITO 1,
                        no uso de suas atribuições conferidas pela Lei nº 6.316/75 e tendo em vista o preconizado
                        no Artigo 6º da Resolução COFFITO nº 423/2013, a qual regulamenta o novo Código de Processo
                        Ético Disciplinar da Fisioterapia e da Terapia Ocupacional.
                    </div>
                    <div className="iDivResolve">RESOLVE:</div>
                    <div className="iDiv1">
                        Art. 1º - Nomear o(a) {processo.membros.instrutorProfissao} {processo.membros.instrutorPronome}
                        &nbsp; {processo.membros.instrutor}, CREFITO {processo.membros.instrutorCrefito} para exercer
                        a função de INSTRUTOR do Processo Ético Disciplinar nº {processo.numeroPed}, no qual figura como
                        parte representada {processo.representado}, CREFITO {processo.numeroCrefito}.
                    </div>
                    <div className="iDiv1">
                        Art. 2º - Esta Portaria entra em vigor a partir desta data.
                    </div>
                    <img src={assinatura} alt="Presidente" className='assPresidente' />
                    <div className="identPresidente">Dr. SILANO SOUTO MENDES BARROS <br /> Presidente</div>
                </div>
                <button className="botaoNPed" onClick={e => voltar(e)}>VOLTAR</button>
                <button className="botaoNPed"
                    style={{ display: 'block', margin: 'auto', marginTop: '1vh' }}
                    onClick={e => imprimir(e)}>IMPRIMIR</button>
            </React.Fragment>
        )
    } else {
        return <div></div>
    }
}

export default InstrutorView